export default __webpack_public_path__ + "static/media/icon-success-circle-green-tick.e52380e8.png";